import { fabric } from 'fabric';
import { FABRIC_CUSTOM_OBJECT, RECT } from '../../../utils';
import { EPS } from '../SwimLaneHorizontal';
import { editTextSwimLaneVertical } from './editText';
import { getSettings, initialControl } from './handleSwimLaneHorizontal';

let eventOn = false;
let swimLane = null;
let onMouseDown;

const controlHeader = new fabric.Rect({ ...initialControl });

function controlSetCoords() {
  const { strokeWidth } = swimLane;
  const settings = getSettings();
  controlHeader.set({
    width: 10 + strokeWidth / 2,
    height: 10 + strokeWidth / 2,
    top: swimLane.top + swimLane.headerHeight + strokeWidth / 2,
    left: swimLane.left + swimLane.width / 2 + strokeWidth / 2,
    ...settings,
  });
  controlHeader.setCoords();
}

function onMouseWheel() {
  controlSetCoords();
}

function onObjMoving(event) {
  const { canvas } = window;
  const { top, textStyle } = swimLane;
  const bottom = swimLane.top + swimLane.height;

  controlHeader.set({
    top: Math.min(Math.max(controlHeader.top, top + textStyle.height + EPS), bottom - EPS),
  });

  if (event.target === controlHeader) swimLane.set({ headerHeight: controlHeader.top - swimLane.top });

  swimLane.setCoords();
  canvas.remove(swimLane);
  swimLane = new fabric.SwimLaneVertical({ ...swimLane });
  canvas.add(swimLane);
  canvas.sendToBack(swimLane);
  controlSetCoords();
}

function onMouseUp(event) {
  const { canvas } = window;
  swimLane.setCoords();
  canvas.remove(swimLane);
  swimLane = new fabric.SwimLaneVertical({ ...swimLane });
  canvas.add(swimLane);
  canvas.sendToBack(swimLane);
  window.canvas.remove(controlHeader);
  window.canvas.setActiveObject(swimLane);

  if (eventOn) {
    if (event.target && event.target === controlHeader) return;
    window.canvas.remove(controlHeader);
    canvas.off('object:moving', onObjMoving);
    canvas.off('mouse:up', onMouseUp);
    canvas.off('mouse:down', onMouseDown);
    canvas.off('mouse:wheel', onMouseWheel);
    eventOn = false;
  }
  canvas.renderAll();
}

function addControl() {
  const { canvas } = window;
  window.canvas.add(controlHeader);
  if (!eventOn) {
    canvas.on('object:moving', onObjMoving);
    canvas.on('mouse:up', onMouseUp);
    canvas.on('mouse:down', onMouseDown);
    canvas.on('mouse:wheel', onMouseWheel);
    eventOn = true;
  }
}

export function deleteControl() {
  const { canvas } = window;
  window.canvas.remove(controlHeader);
  if (eventOn) {
    canvas.off('object:moving', onObjMoving);
    canvas.off('mouse:up', onMouseUp);
    canvas.off('mouse:down', onMouseDown);
    canvas.off('mouse:wheel', onMouseWheel);
    eventOn = false;
  }
}

onMouseDown = function (event) {
  let check = false;
  if (event.target?.isNotObj && event.target?.type === RECT) check = true;
  if (!check) deleteControl();
};

export function addingControlPointsSwimLaneVertical(target) {
  if (
    !target.type ||
    target.type !== FABRIC_CUSTOM_OBJECT.swimLaneVertical ||
    editTextSwimLaneVertical.object === target
  )
    return;
  swimLane = target;
  target.setCoords();
  controlSetCoords();
  controlHeader.set({
    lockMovementX: true,
  });
  addControl();
}

export const handleMouseDblClickSwimLaneVertical = (e) => {
  deleteControl();
  let { target } = e;
  if (!target || target.type !== FABRIC_CUSTOM_OBJECT.swimLaneVertical || editTextSwimLaneVertical.object) return;
  editTextSwimLaneVertical.myRect = new fabric.Rect({
    top: target.top + target.strokeWidth / 2 - target.headerStyle.strokeWidth / 2,
    left: target.left + target.strokeWidth / 2 - target.headerStyle.strokeWidth / 2,
    ...target.headerStyle,
    hasControls: false,
    lockMovementX: true,
    lockMovementY: true,
  });
  editTextSwimLaneVertical.myText = new fabric.Textbox(target.label, {
    textAlign: 'center',
    hasControls: false,
    lockMovementX: true,
    lockMovementY: true,
    ...JSON.parse(JSON.stringify(target.textStyle)),
  });
  editTextSwimLaneVertical.myText.set({
    left: target.left + target.width / 2 + target.strokeWidth / 2,
    top: target.top + target.headerHeight / 2 + target.strokeWidth / 2,
    width: target.width - 10,
    originX: 'center',
    originY: 'center',
  });

  let clnTarget = new fabric.SwimLaneVertical(target);
  window.canvas.add(clnTarget);
  window.canvas.remove(target);
  window.canvas.add(editTextSwimLaneVertical.myRect, editTextSwimLaneVertical.myText);
  window.canvas.setActiveObject(editTextSwimLaneVertical.myText);
  editTextSwimLaneVertical.myText.enterEditing();
  editTextSwimLaneVertical.myText.hiddenTextarea.focus();
  editTextSwimLaneVertical.myText.selectAll();
  editTextSwimLaneVertical.object = clnTarget;
};
